module.exports = __webpack_public_path__ + "img/Lamp_TH.2bf413eb.png";